import moment from 'moment';
import React from 'react';
import './SignatureElement.scss';

const ApproveFiveElement = (props) => {
  return (
    <div className="signature-element reviewed">
      <div className="signed">
        <div className="signed-text">Approved</div>
      </div>
      <div>
        <b>{props.approvedFiveBy}</b> {moment(props.approvedFiveAt).format('HH:mm on MMM D, YYYY')}
        {props.approveCommentFive && <div><b>Notes:</b> {props.approveCommentFive}</div>}
      </div>
    </div>
  );
};

export default ApproveFiveElement;
